import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { AddIcon, CancelIcon } from '../../../common/icons';
import { notifySuccess } from '../../../../services/notification';
import { ADD_HEADER, GET_INFOGO_HEADER_ORGS } from '../../../../graphql/infogo-gql';
import HeaderDetails, { HeaderHandler } from './header-details';
import Button from '../../../common/button';

type HeaderAddProps = {
    orgId: string | null;
    parentHeaderId?: string | null;
    isOpen: boolean;
    toggle: () => void;
}

const HeaderAdd = (props: HeaderAddProps) => {
    const {orgId, parentHeaderId, isOpen, toggle} = props

    const [addHeader, {loading}] = useMutation(ADD_HEADER)
    const [validated, setValidated] = useState<boolean>(false)

    const headerRef = useRef<HeaderHandler>(null)

    const onAddHeader = () => {
        if (headerRef.current && !headerRef.current.validate(true)) {
            return
        }
        let headerInput = headerRef.current && headerRef.current.getHeader()
        addHeader({
            variables: {
                parentId: !parentHeaderId ? orgId: parentHeaderId,
                isParentOrg: !parentHeaderId,
                input: headerInput
            },
            refetchQueries: [{
                query: GET_INFOGO_HEADER_ORGS,
                variables: { orgId: orgId }
            }],
            awaitRefetchQueries: true,
            onError: (error) => {
                headerRef.current!.setError(error);
            },
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onChange = () => {
        setValidated(!!headerRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={toggle} scrollable backdrop="static" autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Add a Header</ModalHeader>
            <ModalBody>
                <HeaderDetails ref={headerRef} onChange={onChange} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={onAddHeader} disabled={!validated}><AddIcon/> Add</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default HeaderAdd
